module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "heading"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "hide"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/Preface#zpre"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zch1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("In the Beginning … : Magico-Religious Behavior of the Paleanthropians")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zsec1",
      "id": "sec1"
    }
  }, [_vm._v("1. "), _c('i', [_vm._v("Orientatio.")]), _vm._v(" Tools to make tools. The “domestication” of fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zsec2",
      "id": "sec2"
    }
  }, [_vm._v("2. The “opaqueness” of prehistoric documents.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zsec3",
      "id": "sec3"
    }
  }, [_vm._v("3. Symbolic meanings of burials.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zsec4",
      "id": "sec4"
    }
  }, [_vm._v("4. The controversy concerning deposits of bones.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zsec5",
      "id": "sec5"
    }
  }, [_vm._v("5. Rock paintings: Images or symbols?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zsec6",
      "id": "sec6"
    }
  }, [_vm._v("6. The presence of woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#zsec7",
      "id": "sec7"
    }
  }, [_vm._v("7. Rites, thought, and imagination among the Paleolithic hunters.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zch2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Longest Revolution: The Discovery of Agriculture—Mesolithic and Neolithic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec8",
      "id": "sec8"
    }
  }, [_vm._v("8. A lost paradise.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec9",
      "id": "sec9"
    }
  }, [_vm._v("9. Work, technology, and imaginary worlds.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec10",
      "id": "sec10"
    }
  }, [_vm._v("10. The heritage of the Paleolithic hunters.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec11",
      "id": "sec11"
    }
  }, [_vm._v("11. The domestication of food plants: Origin myths.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec12",
      "id": "sec12"
    }
  }, [_vm._v("12. Woman and vegetation. Sacred space and periodical renewal of the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec13",
      "id": "sec13"
    }
  }, [_vm._v("13. Neolithic religions of the Near East.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec14",
      "id": "sec14"
    }
  }, [_vm._v("14. The spiritual edifice of the Neolithic.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#zsec15",
      "id": "sec15"
    }
  }, [_vm._v("15. Religious context of metallurgy: Mythology of the Iron Age.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Mesopotamian Religions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec16",
      "id": "sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. “History begins at Sumer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec17",
      "id": "sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Man before his gods.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec18",
      "id": "sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The first myth of the flood.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec19",
      "id": "sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Descent to the underworld: Inanna and Dumuzi.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec20",
      "id": "sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Sumero-Akkadian synthesis.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec21",
      "id": "sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Creation of the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('span', {
    staticClass: "hide"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec22",
      "id": "sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Sacrality of the Mesopotamian sovereign.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec23",
      "id": "sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Gilgamesh in quest of immortality.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#zsec24",
      "id": "sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Destiny and the gods.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("Religious Ideas and Political Crises in Ancient Egypt")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec25",
      "id": "sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. The unforgettable miracle: The “First Time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec26",
      "id": "sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Theogonies and cosmogonies.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec27",
      "id": "sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. The responsibilities of an incarnate god.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec28",
      "id": "sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. The pharaoh’s ascent to heaven.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec29",
      "id": "sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Osiris, the murdered god.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec30",
      "id": "sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Syncope: Anarchy, despair, and “democratization” of the afterlife.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec31",
      "id": "sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Theology and politics of “solarization.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec32",
      "id": "sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Akh-en-Aton, or the unsuccessful reform.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#zsec33",
      "id": "sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Final synthesis: The association Re-Osiris.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("Megaliths, Temples, Ceremonial Centers: Occident, Mediterranean, Indus Valley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec34",
      "id": "sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Stone and banana.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec35",
      "id": "sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Ceremonial centers and megalithic constructions.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec36",
      "id": "sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. The “enigma of the megaliths.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec37",
      "id": "sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Ethnography and prehistory.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec38",
      "id": "sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. The first cities of India.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec39",
      "id": "sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Protohistorical religious concepts and their parallels in Hinduism.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec40",
      "id": "sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Crete: Sacred caves, labyrinths, goddesses.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec41",
      "id": "sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Characteristic features of Minoan religion.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#zsec42",
      "id": "sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. Continuity of the pre-Hellenic religious structures.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Religions of the Hittites and the Canaanites")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec43",
      "id": "sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Anatolian symbiosis and Hittite syncretism.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec44",
      "id": "sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. The “god who disappears.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec45",
      "id": "sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Conquering the Dragon.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec46",
      "id": "sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Kumarbi and sovereignty.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec47",
      "id": "sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. Conflicts between divine generations.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec48",
      "id": "sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. A Canaanite pantheon: Ugarit.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec49",
      "id": "sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. Baal conquers the sovereignty and triumphs over the Dragon.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec50",
      "id": "sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. The palace of Baal.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec51",
      "id": "sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. Baal confronts Mot: Death and return to life.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#zsec52",
      "id": "sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. Canaanite religious vision.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("“When Israel Was a Child”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec53",
      "id": "sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. The first two chapters of Genesis.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec54",
      "id": "sec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. Paradise lost. Cain and Abel.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec55",
      "id": "sec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. Before and after the flood.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "hide"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec56",
      "id": "sec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. The religion of the patriarchs.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec57",
      "id": "sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. Abraham, “Father of the Faith.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec58",
      "id": "sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. Moses and the departure from Egypt.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec59",
      "id": "sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. “I Am Who I Am.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#zsec60",
      "id": "sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. Religion under the judges: The first phase of syncretism.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Religion of the Indo-Europeans. The Vedic Gods")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec61",
      "id": "sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. Protohistory of the Indo-Europeans.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec62",
      "id": "sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. The first pantheon and the common religious vocabulary.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec63",
      "id": "sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. The Indo-European tripartite ideology.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec64",
      "id": "sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64. The Āryans in India.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec65",
      "id": "sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65. Varu"), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṇ")]), _vm._v("a, primordial divinity: Devas and Asuras.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec66",
      "id": "sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66. Varu"), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṇ")]), _vm._v("a, universal king and magician: "), _c('i', [_c('span', {
    staticClass: "font"
  }, [_vm._v("ṛ")]), _vm._v("ta")]), _vm._v(" and "), _c('i', [_vm._v("māyā.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec67",
      "id": "sec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67. Serpents and gods. Mitra, Aryaman, Aditi.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec68",
      "id": "sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68. Indra, champion and demiurge.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec69",
      "id": "sec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69. Agni, chaplain of the gods: Sacrificial fire, light, and intelligence.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec70",
      "id": "sec70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70. The god Soma and the drink of “non-death.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#zsec71",
      "id": "sec71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71. Two Great Gods in the Vedic period: Rudra-Siva and Vi"), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṣ")]), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṇ")]), _vm._v("u.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("India before Gautama Buddha: From the Cosmic Sacrifice to the Supreme Identity Ātman-Brahman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec72",
      "id": "sec72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72. Morphology of the Vedic rituals.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec73",
      "id": "sec73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73. The supreme sacrifices: "), _c('i', [_vm._v("aśvamedha")]), _vm._v(" and "), _c('i', [_vm._v("puru"), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṣ")]), _vm._v("amedha.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec74",
      "id": "sec74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74. Initiatory structure of rituals: Initiation ("), _c('i', [_vm._v("dīk"), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṣ")]), _vm._v("ā")]), _vm._v("), royal consecration ("), _c('i', [_vm._v("rājasūya).")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec75",
      "id": "sec75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75. Cosmogonies and metaphysics.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec76",
      "id": "sec76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76. The doctrine of sacrifice in the "), _c('i', [_vm._v("Brāhma"), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṇ")]), _vm._v("as.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec77",
      "id": "sec77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77. Eschatology: Identification with Prajāpati through sacrifice.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec78",
      "id": "sec78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78. "), _c('i', [_vm._v("Tapas:")]), _vm._v(" Technique and dialectic of austerities.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec79",
      "id": "sec79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79. Ascetics and ecstatics: "), _c('i', [_vm._v("Muni, vrātya.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec80",
      "id": "sec80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80. The Upanishads and the quest of the "), _c('i', [_c('span', {
    staticClass: "font"
  }, [_vm._v("ṛ")]), _c('span', {
    staticClass: "font"
  }, [_vm._v("ṣ")]), _vm._v("is:")]), _vm._v(" How can deliverance from the “fruits” of one’s own acts be obtained?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec81",
      "id": "sec81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81. The identity "), _c('i', [_vm._v("ātman-Brahman")]), _vm._v(" and the experience of “inner light.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#zsec82",
      "id": "sec82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82. The two modalities of the Brahman and the mystery of the "), _c('i', [_vm._v("ātman")]), _vm._v(" captive in matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#zch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("Zeus and the Greek Religion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#zsec83",
      "id": "sec83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83. Theogony and struggles between divine generations.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#zsec84",
      "id": "sec84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84. Triumph and sovereignty of Zeus.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('span', {
    staticClass: "hide"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#zsec85",
      "id": "sec85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85. The myth of the first races: Prometheus, Pandora.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#zsec86",
      "id": "sec86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86. The consequences of the primordial sacrifice.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#zsec87",
      "id": "sec87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87. Man and destiny: The meaning of the “joy of life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Olympians and the Heroes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec88",
      "id": "sec88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88. The fallen great god and the smith-magician: Poseidon and Hephaestus.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec89",
      "id": "sec89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89. Apollo: Contradictions reconciled.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec90",
      "id": "sec90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90. Oracles and purification.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec91",
      "id": "sec91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91. From “vision” to knowledge.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec92",
      "id": "sec92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92. Hermes, “the companion of man.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec93",
      "id": "sec93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93. The goddesses. I: Hera, Artemis.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec94",
      "id": "sec94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94. The goddesses. II: Athena, Aphrodite.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#zsec95",
      "id": "sec95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95. The heroes.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#zch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Eleusinian Mysteries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#zsec96",
      "id": "sec96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96. The myth: Persephone in Hades.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#zsec97",
      "id": "sec97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97. The initiations: Public ceremonies and secret rituals.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#zsec98",
      "id": "sec98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98. Can the Mysteries be known?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#zsec99",
      "id": "sec99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99. “Secrets” and “Mysteries.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("Zarathustra and the Iranian Religion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec100",
      "id": "sec100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100. The enigmas.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec101",
      "id": "sec101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101. The life of Zarathustra: History and myth.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec102",
      "id": "sec102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102. Shamanic ecstasy?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec103",
      "id": "sec103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103. The revelation of Ahura Mazdā: Man is free to choose good or evil.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec104",
      "id": "sec104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104. “Transfiguration” of the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec105",
      "id": "sec105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105. The religion of the Achaemenids.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec106",
      "id": "sec106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106. The Iranian king and the New Year festival.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec107",
      "id": "sec107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107. The problem of the Magi. The Scythians.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec108",
      "id": "sec108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108. New aspects of Mazdaism: The cult of Haoma.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec109",
      "id": "sec109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109. Exaltation of the god Mithra.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec110",
      "id": "sec110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110. Ahura Mazdā and the eschatological sacrifice.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec111",
      "id": "sec111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111. The soul’s journey after death.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#zsec112",
      "id": "sec112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112. The resurrection of the body.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Religion of Israel in the Period of the Kings and the Prophets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec113",
      "id": "sec113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113. Kingship and the monarchy: The apogee of syncretism.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec114",
      "id": "sec114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114. Yahweh and the creature.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec115",
      "id": "sec115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115. Job, the just man tried.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec116",
      "id": "sec116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116. The time of the prophets.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec117",
      "id": "sec117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117. Amos the shepherd. Hosea the ill-loved.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('span', {
    staticClass: "hide"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec118",
      "id": "sec118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118. Isaiah: “A remnant of Israel” will return.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec119",
      "id": "sec119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119. The promise made to Jeremiah.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec120",
      "id": "sec120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120. The fall of Jerusalem. The mission of Ezekiel.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#zsec121",
      "id": "sec121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121. Religious valorization of the “terror of history.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#zch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_vm._v("Dionysus, or Bliss Recovered")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#zsec122",
      "id": "sec122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122. Epiphanies and occultations of a “twice-born” god.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#zsec123",
      "id": "sec123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123. The archaism of some public festivals.")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#zsec124",
      "id": "sec124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124. Euripides and Dionysiac orgiasm.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#zsec125",
      "id": "sec125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125. When the Greeks rediscover the presence of the God.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#not",
      "id": "not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Abbreviations#zabb",
      "id": "abb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Bibliographies#zbib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Present Position of Studies: Problems and Progress. Critical Bibliographies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Index#zind",
      "id": "ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 69
// module chunks = 0